import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCandidateProfilePath } from '../lib/utils/candidateRoutes';

const ZohoUploadResult = ({ result }) => {
  const { t } = useTranslation();
  if (!result) return null;

  return (
    <div className="rounded-lg border border-border bg-muted/30 px-4 py-3 space-y-4">
      <div>
        <p className="text-sm font-semibold text-foreground mb-2">{t('connectAts.uploadFinished')}</p>
        <ul className="text-sm space-y-1 list-none">
          <li className="text-foreground">
            {t('connectAts.total')}:{' '}
            <span className="font-semibold tabular-nums">{result.total}</span>
          </li>
          <li className="text-success">
            {t('connectAts.updated')}:{' '}
            <span className="font-semibold tabular-nums">{result.updated}</span>
          </li>
          <li className="text-warning">
            {t('connectAts.skipped')}:{' '}
            <span className="font-semibold tabular-nums">{result.skipped}</span>
          </li>
          <li className="text-destructive">
            {t('connectAts.failed')}:{' '}
            <span className="font-semibold tabular-nums">{result.failed}</span>
          </li>
        </ul>
      </div>

      {result.skippedCandidates?.length > 0 && (
        <div>
          <p className="text-sm font-medium text-warning mb-1.5">{t('connectAts.skippedCandidates')}</p>
          <ul className="text-sm space-y-1 list-none">
            {result.skippedCandidates.map((candidate) => (
              <li key={`skipped-${candidate.zohoId}`}>
                {candidate.id ? (
                  <Link
                    to={getCandidateProfilePath(candidate.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline"
                  >
                    {candidate.fullName}
                  </Link>
                ) : (
                  <span className="text-muted-foreground">
                    {t('connectAts.notFound', { id: candidate.zohoId })}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {result.failedCandidates?.length > 0 && (
        <div>
          <p className="text-sm font-medium text-destructive mb-1.5">{t('connectAts.failedCandidates')}</p>
          <ul className="text-sm space-y-1 list-none">
            {result.failedCandidates.map((candidate) => (
              <li key={`failed-${candidate.zohoId}`}>
                {candidate.id ? (
                  <Link
                    to={getCandidateProfilePath(candidate.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline"
                  >
                    {candidate.fullName}
                  </Link>
                ) : (
                  <span className="text-muted-foreground">
                    {t('connectAts.notFound', { id: candidate.zohoId })}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ZohoUploadResult;
